module.exports = __webpack_public_path__ + "img/verwaltung-active.3ba81872.svg";